import { render, staticRenderFns } from "./printshop.vue?vue&type=template&id=b6601c8c&"
import script from "./printshop.vue?vue&type=script&lang=js&"
export * from "./printshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports